import React from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, StateManagementProps } from '../../utils/addReduxProps';
import CircularProgress from '@material-ui/core/CircularProgress';
import Swipeable from 'react-swipeable';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import Colors from '../../utils/colors';
import { FullImage } from '../configuration/ConfigurationView';
import ArrowRight from '@material-ui/icons/ArrowRightAlt';
export interface VehicleImageProps {
	useDarkFont?: boolean;
	imageClassName?: string;
	arrowStyle?: object;
}

export interface VehicleImageState {
	loading: boolean;
	error: boolean;
}

export type VehicleImageAllprops = VehicleImageProps & StateManagementProps & WithNamespaces;

export class VehicleImage extends React.Component<VehicleImageAllprops, VehicleImageState> {

	private readonly perspectives = [0, 1, 2];

	private imageStamp: number;

	constructor(props: VehicleImageAllprops) {
		super(props);
		this.state = { error: false, loading: true };
		this.imageStamp = props.imageTimestamp;
	}


	componentDidMount() {
		!this.imageIsCached(this.getImageSrc()) && this.setState({ loading: true });
	}

	componentDidUpdate() {
		if (this.imageStamp !== this.props.imageTimestamp) {
			this.imageStamp = this.props.imageTimestamp;
			this.setState({ loading: true });
		}
	}

	handleSwipe(change: number) {
		let newPosition: number;
		this.imageStamp = Date.now();
		const min = Math.min(...this.perspectives);
		const max = Math.max(...this.perspectives);
		const newValue = this.props.perspective + change;
		newPosition = newValue < min ? max : newValue > max ? min : newValue;
		this.props.setPerspective(newPosition);
		this.setState({ loading: true });
		console.log(newPosition);
	}

	handleImageLoad() {
		this.setState({ loading: false });
	}

	handleImageError() {
		this.setState({ error: true });
	}

	private imageIsCached(src: string) {
		var image = new Image();
		image.src = src;
		return image.complete;
	}

	private getImageSrc() {
		return `${this.getImageBase()}&stamp=${this.props.imageTimestamp}`
	}

	getHeroImage() {
		return `${this.props.selectedModel.Hero.ImageUrl}`
	}

	private getImageBase() {
		return this.props.configuration.FullImages.find((image: FullImage) => {
			return image.Perspective === this.props.perspective
		})!.Url
	}

	render() {

		const { t } = this.props;
		const mainColor = this.props.useDarkFont ? Colors.black : Colors.white
		const fontColor = { color: mainColor };
		const arrowMainColor = {
			...fontColor,
			borderColor: mainColor,

		}
		const arrowStyle = this.props.arrowStyle || {};
		const imageStyle: React.CSSProperties = {
			backgroundImage: `url(${this.getImageSrc()})`,
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat',
			width: '100%',
			backgroundPosition: 'center',
		}

		const vehicleImage = <img
			alt="vehicle"
			onLoad={this.handleImageLoad.bind(this)}
			onError={this.handleImageError.bind(this)}
			style={{ display: 'none' }}
			src={`${this.getImageSrc()}`}
		/>

		const loader =
			<span className="turnable-image">
				<CircularProgress />
				<span className="loading-text" style={fontColor}>{t('vehicleImage.loaderText')}</span>
			</span>
		const error = <div>
			<img alt="error" className="error-image" src={this.getHeroImage()} />
			<div style={fontColor}>Oops! Something went wrong while loading the image...</div>
		</div>

		return (
			<section id="turnable-image-section" className="full-height full-width flex-container centered">
				{!this.state.loading && <div className="full-height flex-container centered">
					<div onClick={() => this.handleSwipe(-1)} id="left-arrow-wrapper" style={arrowMainColor} className="arrow-wrapper clickable">
						<ArrowRight style={arrowStyle} fontSize="large" className="arrow-left" />
					</div>
				</div>}
				<Swipeable
					style={imageStyle}
					className="full-height turnable-image-wrapperr flex-container centered"
					trackMouse={true}
					onSwipedLeft={() => this.handleSwipe(1)}
					onSwipedRight={() => this.handleSwipe(-1)}>
					{this.state.loading && !this.state.error && loader}
					{this.state.loading && this.state.error && error}
					{vehicleImage}
				</Swipeable>
				{!this.state.loading && <div className="full-height flex-container centered">
					<div onClick={() => this.handleSwipe(1)} id="right-arrow-wrapper" style={arrowMainColor} className="arrow-wrapper clickable">
						<ArrowRight style={arrowStyle} fontSize="large" className="arrow-right" />
					</div>
				</div>}
			</section>
		)
	}
}

export default withNamespaces()((connect(mapStateToProps, mapDispatchToProps)(VehicleImage)));
